import styled from 'styled-components'

export const IntegrationChip = styled.div`
  border-radius: 6px;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 2px;
  padding-bottom: 2px;
  user-select: none;
`
